// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=js"
// @generated from file morfi/v1/cmd/proposal_vote.proto (package morfi.v1.cmd, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file morfi/v1/cmd/proposal_vote.proto.
 */
export const file_morfi_v1_cmd_proposal_vote: GenFile = /*@__PURE__*/
  fileDesc("CiBtb3JmaS92MS9jbWQvcHJvcG9zYWxfdm90ZS5wcm90bxIMbW9yZmkudjEuY21kIn8KElByb3Bvc2FsVm90ZVVwZGF0ZRIKCgJ0cxgBIAEoAxIVCg1tYXJrZXRfcHVia2V5GAIgASgJEhQKDHZvdGVyX3B1YmtleRgDIAEoCRIMCgRraW5kGAQgASgNEg8KB3Vwdm90ZXMYBSABKAQSEQoJZG93bnZvdGVzGAYgASgEYgZwcm90bzM");

/**
 * @generated from message morfi.v1.cmd.ProposalVoteUpdate
 */
export type ProposalVoteUpdate = Message<"morfi.v1.cmd.ProposalVoteUpdate"> & {
  /**
   * @generated from field: int64 ts = 1;
   */
  ts: bigint;

  /**
   * @generated from field: string market_pubkey = 2;
   */
  marketPubkey: string;

  /**
   * @generated from field: string voter_pubkey = 3;
   */
  voterPubkey: string;

  /**
   * @generated from field: uint32 kind = 4;
   */
  kind: number;

  /**
   * @generated from field: uint64 upvotes = 5;
   */
  upvotes: bigint;

  /**
   * @generated from field: uint64 downvotes = 6;
   */
  downvotes: bigint;
};

/**
 * Describes the message morfi.v1.cmd.ProposalVoteUpdate.
 * Use `create(ProposalVoteUpdateSchema)` to create a new message.
 */
export const ProposalVoteUpdateSchema: GenMessage<ProposalVoteUpdate> = /*@__PURE__*/
  messageDesc(file_morfi_v1_cmd_proposal_vote, 0);

